import { useNode, useEditor, Element } from "@craftjs/core";
import React, { useContext } from "react";
import { PortalCloseSettings } from "./settings";
import GrigoraCSSRenderer from "./../css-render";
import classNames from "classnames";
import icon from "./icon";
import { createPortal } from "react-dom";
import { GrigoraDashboardContext } from "../../dashboard/context";
import SVG from "react-inlinesvg";
import SVGIcons from "../../input/icons.json";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import { Container } from "../container";
import { CMSPortalCloseSettings } from "./cms-settings";

export const PortalClose = (props) => {
  const {
    editorDocument = document,
    blockState,
    setBlockState,
  } = useContext(GrigoraDashboardContext) ?? {};

  const {
    id,
    connectors: { connect, drag },
    selected,
    actions: { setProp },
    dom,
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
    dom: state.dom,
  }));

  const {
    query: { node },
  } = useEditor();

  const {} = useContext(GrigoraDashboardContext) ?? {};

  const {} = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-portal-close": true,
      [`portal-close-${id}`]: id,
    },
    blockProps.className,
  );

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__PortalClose(id, props)}`}</style>
      <Element is={Container} canvas id={"container"}></Element>
    </div>
  );
};

// To Avoid Mangling in Production
PortalClose.displayName = "PortalClose";

PortalClose.craft = {
  name: "Portal Close",
  props: {},
  related: {
    settings: PortalCloseSettings,
    CMSsettings: CMSPortalCloseSettings,
    icon: icon,
    category: "portal",
    supports: [
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
      "grigora/position",
    ],
    isHiddenInPostEditor: true,
  },
  custom: {
    name: "Portal Close",
    slug: "grigora/portal-close",
  },
};
